<template>
	<div>
		选择预约类型：<el-select v-model="curbooktype" style=" width: 200px;" @change="onBookTypeChanged">
			<el-option v-for="item in booktypelist" :label="item" :value="item">
				{{ item }}
			</el-option>
		</el-select>
		<div>
			<el-radio-group v-model="dateflag" @change="rbtnchanged()">
				<el-radio-button :label="0">一个月内</el-radio-button>
				<el-radio-button :label="1">两个月内</el-radio-button>
				<el-radio-button :label="2">半年内</el-radio-button>
				<el-radio-button :label="3">所有</el-radio-button>
			</el-radio-group>
		</div>
		<div ref='chart' style="width:95%;height:500px"></div>
	</div>
</template>

<script>
	import book from '../../apifunction/Book.js'
	const echarts = require('echarts');
	export default {
		created() {
			this.initData()
		},
		data() {
			return {
				OrderEnt: this.inorder,
				dateflag: '0',
				BookNumData: [],
				ShowBookNumData: [],
				booktypelist: [],
				curbooktype: '',
				qdays: 29
			}
		},
		props: ['inorder'],
		methods: {
			initData() {
				book.StatBookNumByOrderID(this.OrderEnt.CommitCorpID, this.OrderEnt.OrderID)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.BookNumData = JSON.parse(ent.Data);
								let last = ''
								for (let i = 0; i < this.BookNumData.length; i++) {
									this.BookNumData[i].bookdate = this.dateFormat(this.BookNumData[i])
									if (last != this.BookNumData[i].book_type_name)
										this.booktypelist.push(this.BookNumData[i].book_type_name)
									last = this.BookNumData[i].book_type_name;
								}
							} else
								this.BookNumData = []
						} else
							this.$message.info(ent.Msg);
					})
			},
			dateFormat: function(row) {
				var d = row.bookdate
				return this.$moment(d).format("YYYY-MM-DD")
			},
			rbtnchanged() {
				//alert(JSON.stringify(this.BranchEnt) )
				if (this.dateflag == '0') {
					this.qdays = 29;
				}
				if (this.dateflag == '1') {
					this.qdays = 59;
				}
				if (this.dateflag == '2') {
					this.qdays = 180;
				}
				if (this.dateflag == '3') {
					this.qdays = 0;
				}
				this.ShowCharts();
			},
			onBookTypeChanged() {
				this.ShowCharts();
			},
			ShowCharts() {
				if (this.BookNumData.length < 1)
					return;
				var dend = this.CommonFun.GetNowDate();
				var dstart = this.CommonFun.GetDateByAddDay(dend, (-1) * this.qdays);
				this.ShowBookNumData = [];
				for (let i = 0; i < this.BookNumData.length; i++) {
					if (this.qdays == 0) {
						if (this.BookNumData[i].book_type_name == this.curbooktype)
							this.ShowBookNumData.push(this.BookNumData[i]);
					} else {
						if (this.BookNumData[i].bookdate >= dstart && this.BookNumData[i].bookdate <= dend && this.BookNumData[i].book_type_name ==
							this.curbooktype)
							this.ShowBookNumData.push(this.BookNumData[i]);
					}

				}
				let list = this.ShowBookNumData;
				let xvalue = [];
				let yvalue = [];
				for (let i = 0; i < list.length; i++) {
					xvalue.push(list[i].bookdate);
					yvalue.push(list[i].booknum);
				}
				var myChart = echarts.init(this.$refs.chart);
				myChart.setOption({
					title: {
						text: this.curbooktype
					},
					tooltip: {},
					xAxis: {
						data: xvalue
					},
					yAxis: {},
					series: [{
						name: '预约人数',
						type: 'bar',
						data: yvalue
					}]
				});
			}
		}
	}
</script>

<style>
</style>
